import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createThunkErrorHandler } from '../../utils/handleThunkError.js';
import { handlePending } from '../../utils/handlePending.js';
import { getList } from '../../http/proxyAPI.js';


export const getProxyData = createAsyncThunk(
    'proxy/getProxyData',
    async ({ type }, { rejectWithValue }) => {
        try {
            const data = await getList(type)
            
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Login failed')
        }
    }
);



const proxySlice = createSlice({
    name: 'proxy',
    initialState: {
        errors: {},
        globalError: null,
        isLoading: false,
        data: []
    },
    reducers: {
        clearErrors: (state) => {
            state.errors = {}
            state.globalError = null
        },

        clearGlobalError: (state) => {
            state.globalError = null
        }
    },

    extraReducers: builder => {
        builder
            .addCase(getProxyData.pending, (state) => {
                state.isLoading = true
                state.errors = {}
                state.globalError = null
            })
            .addCase(getProxyData.fulfilled, (state, action) => {
                
                state.isLoading = false
                state.data = action.payload.data.list || []
            })
            .addCase(getProxyData.rejected, (state, action) => {
                state.isLoading = false
                state.globalError = action.payload
            })
    }
});

export const {
    clearErrors,
    clearGlobalError,
} = proxySlice.actions;

export default proxySlice.reducer;